/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
    'use strict';

    /**
     * Вид для формы самовывоза
     */
    app.JointPurchaseDeliveryFormView = app.ValidatedFormView.extend({
        el: '',

        templateName: '',

        formElement: '.js-delivery',

        formName: 'delivery',

        globalErrorMsg: 'При сохранении формы организатора совместных покупок',

        events: {
            'change .js-delivery-change': 'validate',
            'focusout .js-delivery-focusout': 'validate',
            'click .js-delete-button': 'deleteForm'
        },

        isRemoved: false,

        run: function (options) {
            if (options && options.districts && options.districts instanceof app.Districts) {
                this.districts = options.districts;
            }
            if (options && options.jpDistricts && options.jpDistricts instanceof app.Districts) {
                this.jpDistricts = options.jpDistricts;
            }
            this.template = app.helpers.TemplateHelper.getTemplate(this.templateName);
            this.listenTo(this.model, 'destroy', this.remove);
        },

        render: function () {
            var element = $(this.template({
                model: this.model,
                hasDistricts: !!(this.districts && this.districts.length)
            }));
            this.setElement(element);
            this._initChildViews();
            return element;
        },

        _initChildViews: function () {
            this.updateFieldsList();
            this.districtPopupView = new app.DistrictPopupView({
                el: this.$('.district-container'),
                districts: this.districts,
                jpModel: this.model
            });
            this.districtPopupView.showDistrictField();
        },

        /**
         * Удаляет форму доставки
         */
        deleteForm: function () {
            this.isRemoved = true;
            this.model.destroy();
        },

        _getField: function (field) {
            return this.$('.' + field);
        },

        _getError: function (field) {
            return this.$('.' + field + '-error');
        }
    });
})(jQuery);

}.call(window));